import styled from 'styled-components'

export default styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  background: var(--very-light-blue);
`
